// vendors
import styled from 'styled-components';
import Img from 'gatsby-image';
import { rem } from 'polished';
import colors from '../../styles/colors';

export const Container = styled.figure`
  display: block;
  max-width: 100%;
  margin: 80px 0;

  break-inside: avoid;

  /* Pour Firefox : */
  page-break-inside: avoid;

  /* Pour WebKit : */

  /* -webkit-column-break-inside: avoid; */
`;

export const StyledPicture = styled(Img)`
  display: block;
  width: 100%;
`;

export const Caption = styled.figcaption`
  display: inline-block;
  min-width: ${rem(208)};

  margin-top: -40px;
  margin-right: 56px;
  margin-left: -28px;
  padding: ${40 + 16}px 28px 16px;

  background-color: ${colors.robinEggBlue};
  mix-blend-mode: multiply;
`;
